interface BrandMarkProps {
  inverted?: boolean
  compact?: boolean
}

export function BrandMark({ inverted = false, compact = false }: BrandMarkProps) {
  return (
    <a className={`brand-mark ${compact ? 'brand-mark--compact' : ''}`} href="/" aria-label="High Times Nug Shots home">
      <span className="brand-mark__high-times">High Times</span>
      <span className={`brand-mark__nug-shots ${inverted ? 'brand-mark__nug-shots--inverted' : ''}`}>
        Nug Shots
      </span>
    </a>
  )
}
